import { ref } from 'vue';

const isMobile = ref(false);

const updateIsMobile = () => {
    if (typeof window === 'undefined') return;
    
    // Check for touch capabilities
    const hasTouch = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
    
    // Check for mobile user agent
    const userAgent = navigator.userAgent.toLowerCase();
    const isMobileDevice = /iphone|ipad|ipod|android|webos|blackberry|iemobile|opera mini/i.test(userAgent);
    
    // Check screen width
    const isSmallScreen = window.innerWidth < 768;
    
    isMobile.value = hasTouch && (isMobileDevice || isSmallScreen);
};

// Initialize on mount
if (typeof window !== 'undefined') {
    updateIsMobile();
    window.addEventListener('resize', updateIsMobile);
}

export default {
    isMobile
}; 